import apiClient from './apiClient';

export interface QueryParams {
  report_types: string[];  // "date","customer","dept","category","bank","slip"
  customer_from?: string;
  customer_to?: string;
  date_from?: string;      // YYYY-MM-DD
  date_to?: string;
  bank_from?: string;
  bank_to?: string;
  dept_from?: string;
  dept_to?: string;
  category_from?: string;
  category_to?: string;
  slip_no_from?: string;
  slip_no_to?: string;
}

export interface ReportRow {
  FG110_01: string;      // payment no
  FG110_11: string;      // payment date
  FG110_32: string;      // entry date
  delay_days: number;
  FG110_MK: string;      // approve mark
  FG110_19: string;      // dept code
  dept_name: string;
  FG110_26: string;      // customer code
  customer_name: string;
  FG110_17: string;      // category code
  category_name: string;
  FG110_25: string;      // currency
  FG110_12: number;      // orig pay amt
  FG110_22: number;      // orig actual amt
  FG110_NT: number;      // TWD actual amt
  FG111_15: string;      // bank code
  bank_name: string;
  FG111_171: string;     // slip no
  F901_111: string;      // operator code
  F901_11: string;       // operator name
  FG110_80: string;      // approve flag
}

export interface CurrencySummary {
  FG110_25: string;
  total_orig_pay: number;
  total_orig_act: number;
  total_twd_act: number;
}

export interface GroupCount {
  code: string;
  name: string;
  count: number;
}

export interface DelayStats {
  employee_code: string;
  record_count: number;
  total_delay: number;
  avg_delay: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  currency_summary: CurrencySummary[];
  twd_total: number;
  group_counts: GroupCount[];
  delay_stats: DelayStats[];
  message?: string;
}

export const g305Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/g305/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/g305/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
